import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	LINKS: '[href^="#"]',
};

class ScrollToAnchorComponent extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}
	didMount() {

		this.on('click',fragments.LINKS, this.handleClickOnLink);
		this.elements = this.element.querySelectorAll(fragments.LINKS);
		var hashId = window.location.hash.substr(1);
		if(hashId !== '') {
			this.scrollToElement(hashId);
		}
	}

	handleClickOnLink = (e) => {
		e.preventDefault();
		const {
		} = this.state;
		this.setState({
		});
		this.scrollToElement(e.target.hash.substr(1));
	}

	scrollToElement = (elementId) => {
		var element = document.getElementById(elementId);
		if(element != null){
			var elementOffsetTop = element.getBoundingClientRect().top + window.pageYOffset;
			window.scroll({
				top: elementOffsetTop, // could be negative value
				left: 0,
				behavior: 'smooth'
			});
		}
	}

	willUnMount() {
		this.elements = null;
	}
	update(prevProps, prevState, inDocument) {
		const {

		} = this.state;
	}
}

export default ScrollToAnchorComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/ScrollToAnchorComponent/ScrollToAnchorComponent.js